// Hero Section Component
import InteractiveSVG from "./SVG component";
import React, { useState } from "react";
import { Link } from 'react-router';

const HeroSection = () => {

    const [email, setEmail] = useState("");
    const [error, setError] = useState("");

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    const handleJoinNow = async () => {
        if (!validateEmail(email)) {
            setError("Please enter a valid email address.");
            return;
        }
        setError("");

        // Add email to Google Sheet
        try {
            const response = await fetch('https://script.google.com/macros/s/AKfycbx1KlhCAKgSrGq1MydMh-6K7NSZr3ck8oiGU6tNtf6G_riRFa0_afy4gphvlK4JZW62/exec', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });
            if (response.ok) {
                alert("Email added successfully!");
                setEmail("");
            } else {
                alert("Failed to add email. Please try again.");
            }
        } catch (error) {
            console.error("Error adding email:", error);
            alert("Failed to add email. Please try again.");
        }
    };


    return (
        <div className="min-h-screen flex items-center justify-center p-4 md:p-20">
            <div className="bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-2xl w-full max-w-6xl flex flex-col md:flex-row overflow-hidden">
                {/* Left Side - Club Heading and Description */}
                <div className="w-full md:w-1/2 p-6 md:p-12 flex flex-col justify-center text-center md:text-left">
                    <h1 className="text-3xl md:text-5xl font-bold mb-4 md:mb-6 text-white leading-tight">
                        HealthoTech Club
                    </h1>
                    <div className="text-base md:text-xl text-white/80 mb-6 md:mb-8 leading-relaxed">
                        <p className="mb-4">
                            Welcome to HealthoTech — bridging healthcare challenges with technological innovation through collaboration and creative problem-solving.
                        </p>
                        <p>
                            Subscribe to our newsletter for industry insights, events, and networking opportunities.
                        </p>
                    </div>
                    <div className="flex flex-col md:flex-row justify-center md:justify-start space-y-4 md:space-y-0 md:space-x-4">
                        <input
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            placeholder="Enter your email"
                            className="bg-white/20 text-white px-6 md:px-8 py-2 md:py-3 rounded-full focus:outline-none focus:ring-2 focus:ring-white/30 transition-colors"
                        />
                        <button
                            onClick={handleJoinNow}
                            className="bg-white/20 text-white px-6 md:px-8 py-2 md:py-3 rounded-full hover:bg-white/30 transition-colors"
                        >
                            Join Now
                        </button>
                        <Link
                            to="/about"
                            className="bg-white/20 text-white px-6 md:px-8 py-2 md:py-3 rounded-full hover:bg-white/30 transition-colors"
                        >
                            Learn More
                        </Link>
                    </div>
                    {error && <p className="text-red-500 mt-4">{error}</p>}
                </div>
                

                {/* Right Side - Interactive SVG */}
                <div className="w-full md:w-1/2 bg-white/10 flex items-center justify-center p-4 md:p-8">
                    <div className="w-full h-full p-4 md:p-8">
                        <InteractiveSVG />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroSection;